
namespace Matrix.Data {

    @Serenity.Decorators.registerClass()
    export class ClientTableGrid extends Serenity.EntityGrid<ClientTableRow, any> {
        protected getColumnsKey() { return 'Data.ClientTable'; }
        protected getDialogType() { return ClientTableDialog; }
        protected getIdProperty() { return ClientTableRow.idProperty; }
        protected getLocalTextPrefix() { return ClientTableRow.localTextPrefix; }
        protected getService() { return ClientTableService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}